import React from "react";
import { Link } from "react-router-dom";

import "./extends.css";
export function ExtendFragance(){
  function chek(){
    if ( window.confirm("¿ IR A PÁGINA The Odin Project ?") ) {
      window.open("https://www.theodinproject.com");
    } else {
      window.alert(
        "¡ Elegiste cancelar ir a The Odin Project ! Estás en Coronados"
      );
    }
  }
  function chek2(){ 
    if ( window.confirm("¿ IR A PÁGINA Cisco Networking Academy ?") ) {
      window.open("https://skillsforall.com");
    } else {
      window.alert( 
        "¡ Elegiste cancelar ir a Cisco Networking Academy ! Estás en Coronados"
      );
    }
  }
  return (
    <>
      <section lang="es" style={{ userSelect: 'none', WebkitUserSelect: 'none' }}>
        <hgroup>
          <h4 className="text_Din din-tittle">
            Programar - Aprender a programar
          </h4>
          <br />
          <h4 className="text_Din din-subtittle">
            Para comenzar es necesario conocimientos bases en manejo de Hardware
            , Software y navegación en internet ... además recursos: Netbook ,
            Notebook o Pc ... de igual modo conexión a internet ... luego la
            parte individual curiosidad o ganas de aprender , paciencia y sobre
            todas las cosas tiempo .
          </h4>
          <br />
          <h4 className="text_Din din-epigraph">
            En esta parte de la web te comento de dos páginas que ofrecen muy
            buenos cursos sobre todo , si crees que tienes conocimientos básicos
            y cuentas con los recursos para poner practica a las explicaciones
            además, las distintas opciones de cursos de las dos páginas otorga
            certificado pero claro que ahí condiciones antes de viajar a ver la
            página te recomiendo que leas todo lo que sigue aquí debajo te
            cuento que necesitas descargar , programas necesarios ,
            instalaciones si te interesa el certificado y aparte de esto te
            cuento que esta seccion tiene un protocolo de seguridad al momento
            de dirijirte hacia las paginas del curso...{" "}
            <code>( Clics de confirmación )</code>{" "}
          </h4>
          <br />
        </hgroup>
        <hr />
        <br />
        <br />
        <article>
          <h4 className="text_Din __id"> The Odin Project </h4>
          <p className="text_Din _paragraph">
            https://www.theodinproject.com ofrece un curso que contiene 10
            opciones para aprender distintos lenguajes de programas y sobre todo
            si te interesa aprender desde cero contiene buena pedagogía que
            ayuda bastante. Por otra parte, podemos traducir continuamente al
            español todas las explicaciones de teoría; las explicaciones
            prácticas{" "}
            <code className="text_Din">
              (videos grabados explican paso a paso un código "tal" [sintaxis ,
              palabras , ejecución y muestra]
            </code>{" "}
            son redactadas en inglés por lo tanto complica la traducción esta
            parte es sin opción de traducción. Antes de ir a chequear la web te
            recomiendo que leas lo que continua ya que te puede ayudar y quizás
            no pierdas tiempo porque lógicamente no es cosa de todos los días o
            super fácil arrancar con las condiciones necesarias. Por empezar The
            Odin Student es una página que ofrece un certificado al terminar el
            curso seleccionado, aunque lo interesante es aprender si quisiéramos
            hacer el curso de un modo improvisado podríamos arrancar ya mismo
            sin respetar las condiciones de la academia, pero si te interesa
            alcanzar el examen tendría que sin otra alternativa ingresar con las
            condiciones que exige la academia, te explico...
          </p>
          <br />
          <ol className="orderList">
            {" "}
            <h4 className="text_Din">Cursos que ofrecen</h4>
            <li>
              Intermediate HTML And CSS... son dos lenguajes para diseño y
              desarrollo web... principiante
            </li>
            <li>Advanced HTML And CSS</li>
            <li>Ruby</li>
            <li>DataBase lenguaje especifico almacenamiento... principiante</li>
            <li>NodeJs programación web... avanzado</li>
            <li>
              JavaScript programación web intermedio{" "}
              <code>(Estructura con Html y Css pero no es lo mismo)</code>
            </li>
            <li>Getting</li>
            <li>Hired</li>
            <li>React</li>
            <li>
              Ruby on Rials... Web Comercial , Carrito de compras , Productos...
              avanzado
            </li>
          </ol>
          <br />
          <p className="text_Din _paragraph">
            Cada uno de estos 10 puntos son cursos y lenguajes de programas
            tendría que elegir uno que quieras o te interese puede consultar
            para que sirven y en que se utilizan. Para comenzar es necesario ser
            un estudiante de The Odin para esto registras con tu navegador ,que
            sería tan sencillo como decirle que si a continuar con Google , o
            también con tu Email o de modo personalizado ingresando nombre
            apellido... etc. Si te registras podes por ejemplo ver tu nombre en
            cada lugar o por ejemplo controlar las secciones, cerrar la sección
            de igual modo que en alguna red social y volver tiempo después
            iniciar la sección y dirigirte donde estabas, ademas esta parte va
            realizando un chequeo automático de la trayectoria que cumpliste ,
            por ejemplo donde estabas la última vez o donde iniciaste en el día.
            Esto anterior es sencillo y a partir de esto puedes arrancar si
            quieres ya mismo y recorrer todo el curso. Pero para concursar con
            las condiciones de certificación final faltan algunos puntos de los
            que te comento por arriba y "al trote" quizás entiendas las
            condiciones y sepas que hacer no sería agradable comenzar en esto y
            de repente las condiciones nos superan.
            <br />
            Como explica en la introducción una vez que ingresas con tu usuario
            The Odin necesitamos un IDE que es un decodificador de lenguajes de
            programas este "IDE" que exige la académica se llama "VisualCode" y
            se descarga gratuitamente y es de instalación sencilla{" "}
            <code>( https://code.visualstudio.com/ )</code>. Los lenguajes de
            programas de los cursos usan este "IDE" cualquiera de los 10 ; otro
            ítem que puede ayudarte es que necesitan una instalación particular
            alguno de estos cursos: Ruby DataBase NodeJs Hired React Y Rials. Al
            revés: Html css y javascript se pueden escribir y ejecutar solamente
            con este "IDE" y obviamente cualquier navegador web . Ahora sí... el
            proceso para registrar tus prácticas se hacen con un Repositorio Web
            llamado "GitHub"{" "}
            <code>
              (Tu lugar donde almacenar tamaño de información pero no fotos o
              videos, códigos)
            </code>{" "}
            en este lugar enviamos y quedan almacenadas los ejercicios, "GitHub"
            no necesita descargarse solo registrarse en la página de "GitHub".
            Ahora continua la parte que exige un poco , en ninguno de los cursos
            se puede utilizar el sistema operativo "Windows" por lo tanto una
            condición es contar con "Linuk" , "Ubuntu" , "Mac" ... etc{" "}
            <code>
              [si usas un S.O de estos ya mismo podes ir a la página porque no
              necesitas nada más... ]
            </code>{" "}
            <Link
              className="linkDin"
              to={""}
              target="_blank"
              onClick={(e) => {
                e.preventDefault();
                chek();
              }}
            >
              https://www.theodinproject.com
            </Link>{" "}
            pero si windows es el sistema operativo que utilizas es necesario
            utilizar una "máquina virtual" con sistema operativo de Linux... es
            un ejemplo: VirtualBox Con Ubuntu de Linux{" "}
            <code>
              [ Recomendación: solo continua con esto si tiene conocimiento si
              sabes o crees que lo vas a hacer bien , ¡¡ no descargues "S.O" o
              "máquina virtual" porque si erras podrías después encontrarte
              pagando arreglos !! ].
            </code>
            <br />
            La "máquina virtual" se descarga de https://www.virtualbox.org y el
            sistema operativo de "https://ubuntu.com" descargar estos dos y
            luego... Explicación: La máquina virtual cumple la función de
            hardware , la instalas y veras el icono en el escritorio de tu PC
            como si fuera cualquier otro programa le darás doble clic y listo...
            estarías "encendiendo otra computadora" nada se apaga o reinicia es
            solo un programa nada peligroso... entonces en esta máquina vas a
            tener el sistema operativo alternativo por ejemplo Ubuntu que es una
            versión moderna de Linuk... para todo este paso tenemos que leer y
            chequear la información que nos ofrece The Odin ... no parece
            sencillo pero no es imposible , además alguien con experiencia puede
            ayudarte. Esto es todo lo que exige The Odin para certificar el
            curso gratuitamente.
          </p>
        </article>
      </section>
      <br />
      <section>
        <article>
          <h4 className="text_Din __id"> Cisco Networking Academy </h4>
          <p className="text_Din _paragraph">
            https://skillsforall.com es a mi entender la mejor que se pueden
            encontrar. Nuestra segunda página es académica Cisco Networking
            Academy y cuenta con una amplia rama de cursos desde como por
            ejemplo Ciberseguridad{" "}
            <code>
              ( Defensas de Red , Administración de Amenazas Cibernéticas ,
              Seguridad de Terminales... )
            </code>
            ; Programación{" "}
            <code>
              ( Python 1 intro , Python 2 avanced , JavaScript 1 , JavaScript 2)
            </code>
            ; Redes ; Ciencia de Datos ; Sistemas Operativos , TI{" "}
            <code>( Hardware y Entornos )</code>; Interés Informático...
            entonces estas son las ramas de cursos y para completar lo excelente
            esta es solo la categoría de "cursos" ... tenemos para continuar con
            módulos, recursos , carreras profesionales{" "}
            <code>
              ( Técnico de redes [70 horas] , Analista Junior de Ciberseguridad
              [120 horas]... entre otras muy interesantes )
            </code>{" "}
            ... a todo esto , lo podes englobar en uno de los niveles
            Principiante o Intermedio , no precisamos instalaciones o descargas
            , tampoco un sistema operativo puntual y como si fuera poco así de
            esta manera concursa por certificado{" "}
            <code>( Cursos con certificación )</code> . Con respecto al idioma
            es lo bueno la mayoría de los cursos no tiene explicaciones practica
            solo explicaciones teóricas y todas son traducidas el español ,
            aunque por ejemplo en la parte de recursos en caso de precisarlo
            están los videos sobre el contexto de los distintos cursos.
          </p>
          <br />
          <ol className="orderList">
            {" "}
            <h4 className="text_Din">Cursos que ofrecen</h4>
            <li>La seguridad cibernética</li>
            <li>Redes</li>
            <li>Sistemas operativos y TI</li>
            <li>Ciencias de datos</li>
            <li>Programación</li>
          </ol>
          <br />
          <p className="text_Din _paragraph">
            En cuanto a lo pedagógico tiene una interfaz moderna que está bien
            armada , se comprende , es sencilla y se entiende fácil si tratamos
            , si nos movernos por la página cuidadamente , es mejor prestar
            atención como está dispuesto el contenido , donde se encuentra tu
            perfil y tener en cuenta donde comienza la página , por donde están
            los cursos y donde está el que estas cursando . Esta página también
            sabe cuánto estás en un módulo , si llegaste hasta la mitad del
            mismo , si usaste la pantalla de práctica... por ejemplo cuando
            vuelvas a iniciar la sección e ingreses al curso directamente te
            lleva al último punto que leías . Para tener en cuenta estamos
            hablando de cursos como JavaScript , Python , Ciberseguridad son
            lenguajes que necesitamos tener algún conocimiento previo{" "}
            <code> ( de todos modos las explicaciones están ) </code> ya que los
            módulos tratan algunos "ítem" como conocido con explicaciones
            superficiales y avanza directamente con la puesta teórica y la
            implementación practica del "mismo" en el lenguaje que estudiamos.
            Por otra parte , los ejercicios sobre lo aprendido se responden por
            general a lo último del módulo ya sea con multiplecheck o
            escribiendo código en la pantalla de la página... se envía y
            responde ahí mismo la nota entonces puedes continuar con lo
            siguiente . Para tener en cuenta es necesario conocer antes de
            responder y enviar el ejercicio de un módulo si el resultados genera
            permisos para continuar con lo siguiente{" "}
            <code>
              ( en algunos cursos el resultado permite y deniega también )
            </code>
            ... tener en cuenta.
          </p>
          <br />
          <p className="text_Din _paragraph">
            En esta opción de página ya casi estaría terminando y pasándote la
            dirección para que vallas a navegarla porque es super dinámica en su
            modo de interactuar con los usuarios desde ya que necesitamos
            inscribirnos para ser un estudiante con la cuenta de Google
            eligiendo ingresar con Google o Gmail la que compartas o también
            podríamos hacer el ingreso con un correo electrónico y es todo no
            precisamos ni siquiera un "IDE" ya que cuando vamos avanzando en las
            explicaciones nos ofrecen una pantalla donde podemos escribir el
            código para practicar, de todos modos sería más fácil y dinámico
            tener el "IDE" descárgalo desde aquí https://code.visualstudio.com/.
            Este es el link de Cisco Networking Academic{" "}
            <Link
              className="linkDin"
              to={""}
              target="_blank"
              onClick={(e) => {
                e.preventDefault();
                chek2();
              }}

            >
              https://skillsforall.com
            </Link>
            {" ."}
            <br />
            Si Queres saber ventajas y desventajas de cada cual abajo algunas:
            Para hacer una comparación con nuestra primera página y descubrir
            alguna ventajas y desventajas ente ellas: The Odin Project es una
            opción más pedagógica por eso es más estricta en sus condiciones y
            los resultados se logran de a poco siendo constante y con esfuerzo
            es probable que avancemos y aprendamos bastante, ademas otra carta
            que tiene motivación en The Odin son los lenguajes de programas que
            ofrece atractivos en su rol por ejemplo HTML y su complemento Css o
            otra rama bien distinta pero dispensable DataBase... además los
            cursos comienzan "bien de cero" lo cual es una ventaja que convence
            a la hora de comparar. Ventajas : Aprendizaje desde cero ,
            Inscripción , Certificación , Lenguajes , Idioma , Nivel
            principiante , Interacción , Interfaz amigable , Explicaciones
            claras , La plataforma de trabajo que propone. Desventaja :
            Condiciones exigidas para los principiantes , Instalaciones ,
            Manejar "GitHub" con terminal <code>(no es fácil)</code> , Tiempo
            nesesario.
          </p>
          <p className="text_Din _paragraph">
            Cisco Networking Academy es la opción más intensiva y nos ayuda a
            arrancar de una vez con un lenguaje empezamos a leer a saber cuales
            palabras son estrictas y única de los lenguaje , que se resaltan en
            distintos colores que cumplen un rol ... arrancamos rápido ,
            continuamos donde dejamos la última vez , vemos en que sitio de
            curso nos encontramos <code>( "Módulos" )</code>
            Ventajas: Condiciones, Certificación, Sin descargas, Sin
            instalaciones, Idioma, Teoría, Diversidad de lenguajes, Inscripción,
            Usuario y perfil, Interfaz Moderna, tiempo necesario. Desventajas:
            Intensidad, Practicas, Correcciones de prácticas, Conocimientos
            básicos de programación.
          </p>
        </article>
      </section>
      <br />
      <br />
      <hr />
    </>
  );
}



